import { render } from "./TariffStart.vue?vue&type=template&id=7bff71ca&scoped=true"
const script = {}

import "./TariffStart.vue?vue&type=style&index=0&id=7bff71ca&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bff71ca"]])

export default __exports__